import { render, staticRenderFns } from "./RetentionRules.vue?vue&type=template&id=2ea72d56&"
import script from "./RetentionRules.vue?vue&type=script&lang=js&"
export * from "./RetentionRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports